<div class="header" [ngClass]="{'sticky' : isSticky && !isFullScreen, 'invert' : isSchoolPage && !isFullScreen}" fxLayout="column">
    <div *ngIf="isBannerOpen" class="banner" fxLayoutAlign=" center">
      <div fxHide.lt-md class="banner-content" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="32px">
          <div class="banner-desktop-highlight" ngClass.lt-lg="tablet">Black Friday Deal</div>
          <div class="banner-desktop-text" ngClass.lt-lg="tablet">Up to 30% off our service fee. Use coupon code <span class="banner-text-highlight-color">BLACKFRIDAY</span> at checkout. Valid till November 30, 2022</div>
        </div>
        <div fxFlex="10" fxLayoutAlign="end">
          <button mat-icon-button (click)="closeBanner()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <div fxHide.gt-sm class="banner-content" fxLayout="row" fxLayoutAlign=" center">
        <div fxFlex="22" fxLayout="column">
          <div class="banner-mobile-highlight">30% OFF</div>
          <div class="banner-mobile-sub-highlight">until Nov 30</div>
        </div>
        <div fxFlex="68" class="banner-mobile-text">
          Use coupon code <span class="banner-text-highlight-color">BLACKFRIDAY</span> at checkout to get a discount on our service fee
        </div>
        <div fxFlex="10" fxLayoutAlign="end">
          <button mat-icon-button (click)="closeBanner()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="header-content" fxLayout="row" fxLayoutAlign="space-between center">      
        <a class="header_logo" [routerLink]="['/']"></a>

        <!-- mobile bar -->
        <div *ngIf="!isMenuHidden" fxHide.gt-sm style="color: white;">
            <!-- <button *ngIf="!isLoggedIn()" mat-flat-button class="sign-up-button" [routerLink]="['/','session','sign-up']">sign up</button> -->
            <!-- <button *ngIf="isLoggedIn() && !isMobileNotificationsOpen"  mat-icon-button>
                <mat-icon matBadge="2" matBadgeSize="small" (click)="isMobileNotificationsOpen = !isMobileNotificationsOpen; isMobileMenuOpen = false">notifications</mat-icon>
            </button>
            <button *ngIf="isLoggedIn() && isMobileNotificationsOpen" mat-icon-button>
                <mat-icon (click)="isMobileNotificationsOpen = !isMobileNotificationsOpen; isMobileMenuOpen = false">close</mat-icon>
            </button> -->

            <button mat-icon-button (click)="openSearch()">
                <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!opened">
                <mat-icon (click)="opened=true;sidenav.toggle()">menu</mat-icon>
            </button>
            <button mat-icon-button *ngIf="opened">
                <mat-icon (click)="sidenav.toggle()">close</mat-icon>
            </button>
        </div>

        <!-- desktop bar-->
        <div *ngIf="!isMenuHidden" fxHide.lt-md class="header_menu" fxLayout="row" fxLayoutGap="32px" fxLayoutAlign="space-between center">
            <div *ngIf="!isLoggedIn()" fxLayout="row" fxLayoutGap="32px" fxLayoutAlign=" center">
                <div fxLayout="row" fxLayoutGap="8px">
                <button mat-icon-button [fxHide]="isLandingPage" (click)="openDesktopSearch()"><mat-icon>search</mat-icon></button>
                <button mat-icon-button [fxHide]="!isLandingPage" (click)="scrollToSearch()"><mat-icon>search</mat-icon></button>
                <button mat-flat-button class="sign-in-button" [routerLink]="['/','session','log-in']" [queryParams]="{returnUrl: getPageUrl()}">Login</button>
                <button mat-stroked-button class="sign-up-button" [routerLink]="['/','session','sign-up']" [queryParams]="{returnUrl: getPageUrl()}">Register</button>
                </div>
            </div>

            <div [fxHide]="!isLoggedIn()" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign=" center">
                <div fxLayout="row" fxLayoutGap="32px" fxLayoutAlign=" center">
                    <div *ngIf="isAgent()" [routerLink]="['/','agent','dashboard']">Dashboard</div>
                    <div 
                        #tooltip="matTooltip" [routerLink]="['/','user','applications']" routerLinkActive="active-link" [matTooltipDisabled]="!showApplicationTooltip"
                        [matTooltip]="'You can access your shortlisted programs\nfrom here at any time'" matTooltipPosition="below" matTooltipClass="pave-tooltip pave-dark-tooltip bottom-arrow-dark-tooltip"
                    >
                        My Applications
                    </div>
                    <div *ngIf="isAgent()" [routerLink]="['/','agent','students']">My Students</div>
                </div>
                <mat-divider [vertical]="true" style="width: 4px; height: 20px"></mat-divider>
                <button mat-icon-button [fxHide]="isLandingPage" (click)="openDesktopSearch()"><mat-icon>search</mat-icon></button>
                <button mat-icon-button [fxHide]="!isLandingPage" (click)="scrollToSearch()"><mat-icon>search</mat-icon></button>
                <div [matMenuTriggerFor]="userMenu" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
                    <div class="user-menu-image-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="user-menu-image" fxLayoutAlign="center center" *ngIf="getProfileImage() !== 'null'"
                        [style.background-image]="getProfileImage() ? 'url(' + (getProfileImage() | presignedView | async) + ')': '-'"            
                    >
                    </div>
                    <div class="user-menu-image" fxLayoutAlign="center center" *ngIf="getProfileImage() === 'null'">
                        <mat-icon>person</mat-icon>
                    </div>
                    <mat-icon>menu</mat-icon>
                    </div>
                    <!-- <mat-icon>keyboard_arrow_down</mat-icon> -->
                </div>
            </div>
        </div>
    </div>

    <!-- mobile menu -->
    <div class="padded mobile-menu" fxLayout="column" [@toggleMenu]="isMobileMenuOpen ? 'open' : 'closed'">
        <div fxLayout="row" fxLayoutAlign="space-between">
            <div [routerLink]="['/']">Home</div>
            <app-currency-selector></app-currency-selector>
        </div>
        <div *ngIf="!isLoggedIn()">About</div>
        <div *ngIf="!isLoggedIn()">Services</div>
        <div *ngIf="!isLoggedIn()" [routerLink]="['/','contact']">Contact</div>
        <div *ngIf="isLoggedIn()"  [routerLink]="['/','services','student','search']">Schools and Courses</div>
        <div *ngIf="isLoggedIn() && isAgent()" [routerLink]="['/','agent','dashboard']">Dashboard</div>
        <div *ngIf="isLoggedIn()" [routerLink]="['/','user','applications']">My Applications</div>
        <div *ngIf="isLoggedIn() && isAgent()" [routerLink]="['/','agent','students']">My Students</div>
        <div *ngIf="isLoggedIn()" [routerLink]="['/','contact']">Contact</div>
        <div *ngIf="isLoggedIn() && !isAgent()" [routerLink]="['/','user','profile']">Profile</div>
        <mat-divider *ngIf="isMobileMenuOpen"></mat-divider>
        <div *ngIf="!isLoggedIn()" style="text-transform: uppercase;" [routerLink]="['/','session','log-in']">Sign in</div>
        <div *ngIf="isLoggedIn()" style="text-transform: uppercase;" (click)="logout()">Sign out</div>
    </div>

    <!-- mobile notifications menu -->
    <div class="padded mobile-menu notification-menu" fxLayout="column" fxLayoutGap="8px" [@toggleMenu]="isMobileNotificationsOpen ? 'open' : 'closed'">
        <div class="notification-item" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
            <div class="school-emblem"></div>
            <div fxFlex>Would you be interested in some skunk?</div>
        </div>
        <div style="font-size: smaller;">1:32 PM</div>
        </div>
        <mat-divider></mat-divider>
        <div class="notification-item" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
            <div class="school-emblem"></div>
            <div fxFlex>Would you be interested in some skunk?</div>
        </div>
        <div style="font-size: smaller;">1:32 PM</div>
        </div>
        <mat-divider></mat-divider>
        <div class="notification-item" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
            <div class="school-emblem"></div>
            <div fxFlex>Would you be interested in some skunk?</div>
        </div>
        <div style="font-size: smaller;">1:32 PM</div>
        </div>
    </div>

    <!-- desktop search -->
    <div class="desktop-search" fxLayout="column" [@toggleMenu]="isDesktopSearchOpen ? 'open' : 'closed'">
        <div fxLayout="row" fxLayoutGap="32px" fxLayoutAlign="center center">
        <app-search-bar source="search_bar"></app-search-bar>
        <button mat-icon-button (click)="closeDesktopSearch()">
            <mat-icon>close</mat-icon>
        </button>
        </div>
    </div>
</div>
  
<!-- application menu (unused)-->
<mat-menu #applicationMenu="matMenu" [xPosition]="'before'">
  <button mat-menu-item [routerLink]="['/','user','applications']">view applications</button>
  <button mat-menu-item [routerLink]="['/','user','shortlist']">view shortlist</button>
</mat-menu>

<!-- desktop profile menu display -->
<mat-menu #userMenu="matMenu" [xPosition]="'before'" class="menu-lower-panel menu-rounded-panel" [ngClass]="{'menu-flat-top-panel': isSticky}">
  <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px" style="padding: 16px; background-color: #FAFAFF;">
    <div class="user-menu-image no-chrome" fxLayoutAlign="center center" *ngIf="getProfileImage() !== 'null'"
      [style.background-image]="getProfileImage() ? 'url(' + (getProfileImage() | presignedView | async) + ')': '-'"            
    ></div>
    <div class="user-menu-image no-chrome" fxLayoutAlign="center center" *ngIf="getProfileImage() === 'null'">
        <mat-icon>person</mat-icon>
    </div>
    <div fxLayout="column">
      <div style="width: 160px; overflow: hidden; text-overflow: ellipsis; font-size: small; font-weight: 500;">{{getProfileName()}}</div>
      <div style="width: 160px; overflow: hidden; text-overflow: ellipsis; font-size: x-small;">{{getProfileEmail()}}</div>
    </div>
  </div>
  <button *ngIf="!isAgent()" mat-menu-item [routerLink]="['/','user','profile']">Profile</button>
  <button *ngIf="false" mat-menu-item (click)="showReferModal()">Refer & Earn</button>
  <button mat-menu-item (click)="logout()">Logout</button>
</mat-menu>

<!-- notifications menu -->
<mat-menu #notificationsMenu="matMenu" [xPosition]="'before'" class="menu-lower-panel">
  <div mat-menu-item fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
      <div class="school-emblem"></div>
      <div fxFlex>Would you be interested in some skunk?</div>
    </div>
    <div class="notification-time">1:32 PM</div>
  </div>
  <mat-divider></mat-divider>
  <div  mat-menu-item fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
      <div class="school-emblem"></div>
      <div fxFlex>Would you be interested in some skunk?</div>
    </div>
    <div class="notification-time">1:32 PM</div>
  </div>
  <mat-divider></mat-divider>
  <div  mat-menu-item fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
      <div class="school-emblem"></div>
      <div fxFlex>Would you be interested in some skunk?</div>
    </div>
    <div class="notification-time">1:32 PM</div>
  </div>
</mat-menu>

<mat-menu #studentMenu="matMenu">
  <button mat-menu-item [routerLink]="['/','services','student','coupon','ulesson']">Learning discounts</button>
</mat-menu>

<mat-menu #schoolMenu="matMenu">
  <button mat-menu-item>Marketing</button>
</mat-menu>

<!-- mobile side nav -->
<mat-sidenav-container class="sidenav-container" style="background: transparent; z-index: 2147483647;" [ngClass]="{'opened': opened}">
  <mat-sidenav style="width: 80%;" #sidenav mode="over" position="end" [(opened)]="opened" (opened)="opened=true" (closed)="opened=false" autoFocus="false" fixedInViewport="true">
    <div fxLayout="column" fxLayoutAlign="space-between" style="background-color: white; height: 100%">
      <div class="sidenav-menu" fxLayout="column">
        <div *ngIf="isLoggedIn()" fxLayout="row" fxLayoutAlign="space-between center" style="padding: 48px 16px 16px 16px; background-color: #FAFAFF; margin-bottom: 16px;">
          <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
            <div class="user-menu-image no-chrome" fxLayoutAlign="center center" *ngIf="getProfileImage() !== 'null'"
              [style.background-image]="getProfileImage() ? 'url(' + (getProfileImage() | presignedView | async) + ')': '-'"            
            ></div>
            <div class="user-menu-image no-chrome" fxLayoutAlign="center center" *ngIf="getProfileImage() === 'null'">
                <mat-icon>person</mat-icon>
            </div>
            <div fxLayout="column">
              <div style="width: 160px; overflow: hidden; text-overflow: ellipsis; font-size: small; font-weight: 500;">{{getProfileName()}}</div>
              <div style="width: 160px; overflow: hidden; text-overflow: ellipsis; font-size: x-small;">{{getProfileEmail()}}</div>
            </div>
          </div>
          <button mat-icon-button (click)="sidenav.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="!isLoggedIn()" class="colored-text" style="padding: 48px 16px 16px 16px; background-color: #FAFAFF; margin-bottom: 16px; font-weight: 500;">
          <div>Create your Pave account</div>
          <button mat-icon-button (click)="sidenav.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div *ngIf="isLoggedIn()" class="menu-item" [routerLink]="['/']" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active-link">Home</div>
        <div *ngIf="isAgent()" class="menu-item" [routerLink]="['/','agent','dashboard']" routerLinkActive="active-link">Dashboard</div>
        <div *ngIf="isLoggedIn()" class="menu-item" [routerLink]="['/','user','applications']" routerLinkActive="active-link">My Applications</div>
        <div *ngIf="isAgent()" class="menu-item" [routerLink]="['/','agent','students']" routerLinkActive="active-link">My Students</div>
        <div *ngIf="isLoggedIn() && !isAgent()" class="menu-item" [routerLink]="['/','user','profile']" routerLinkActive="active-link">Profile</div>
        <div *ngIf="false" class="menu-item" routerLinkActive="active-link" (click)="showReferModal();sidenav.toggle()">Refer & Earn</div>
        <ul *ngIf="!isLoggedIn()" class="colored-text">
          <li class="purple-tick">Access to 2,200+ programs</li>
          <li class="purple-tick">100% success rate</li>
          <li class="purple-tick">Free counselling</li>
          <li class="purple-tick">Visa & settlement support</li>
        </ul>
        <p *ngIf="!isLoggedIn()" class="colored-text" style="padding: 16px; font-size: smaller;">
          Sign up if you do not have an account, or login to access your account
        </p>
        <div fxLayout="column" fxLayoutGap="16px" style="padding: 16px;">
          <button mat-raised-button *ngIf="!isLoggedIn()" color="primary" class="pave-button" [routerLink]="['/','session','sign-up']">Register</button>
          <button mat-stroked-button *ngIf="!isLoggedIn()" color="primary" class="pave-button" [routerLink]="['/','session','log-in']">Login</button>
        </div>
      </div>        
      <div fxLayout="column">
        <div style="padding: 16px;" fxLayout="column" fxFlex>
          <app-currency-selector [dark]="true"></app-currency-selector>
        </div>
        <div *ngIf="isLoggedIn()" style="padding: 32px 16px; border-top: 0.5px solid #D8DBDE;">
          <div class="warning" (click)="logout()">Logout</div>
        </div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
